exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".opportunities--header--3326RZYK {\r\n  margin-top: 0;\r\n  font-weight: 300;\r\n  padding-left: 16px;\r\n  color: #0072CE;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n\r\n\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/views/opportunities/opportunities.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;CACrB","file":"opportunities.css","sourcesContent":[".header {\r\n  margin-top: 0;\r\n  font-weight: 300;\r\n  padding-left: 16px;\r\n  color: #0072CE;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "opportunities--header--3326RZYK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/views/opportunities/opportunities.css
// module id = 442
// module chunks = 0